import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { createGlobalStyle } from 'styled-components';

import * as colors from '../shared/colors';
import { JsDataGlobalNotice } from '../shared/components/GlobalNotice';
import { CollectFeedbackQuestionType } from '../shared/types';
import CollectFeedback from './CollectFeedback';

export interface IQuestion {
    id: string;
    nr: number;
    type: CollectFeedbackQuestionType;
    question: string;
    translation: string | null;
    leftLabel: string | null;
    rightLabel: string | null;
    leftTranslation: string | null;
    rightTranslation: string | null;
}

export interface IData {
    id: string;
    firstName: string;
    lastName: string;
    profilePicSrc: string | null;
    heading: string;
    description: string | null;
    questions: IQuestion[];
    open: boolean;
    anonymous: boolean;
}

// init function
export default function init() {
    const ColorStyles = createGlobalStyle`
        a {
            color: ${colors.primaryColor};
        }
        a:hover, a:active, a:focus {
            color: ${colors.primaryLighter};
        }
        button, .button {
            background-color: ${colors.primaryColor};
        }
        button:hover, .button:hover, button:active, .button:active {
            background-color: ${colors.primaryLighter};
        }
        button.disabled, button[disabled], .button.disabled, .button[disabled] {
            background-color: ${colors.primaryDarker};
        }
    `;

    const data = JSON.parse(document.getElementById('collect-feedback-data').innerHTML) as IData;

    const container = document.getElementById('collect-feedback-page');
    const root = createRoot(container);
    root.render(
        <>
            <JsDataGlobalNotice />
            <CollectFeedback data={data} />
            <ColorStyles />
        </>,
    );
}
